module.exports = __webpack_public_path__ + "static/play_button-e50aeb86a6456f3058f0eb0e2ebce142.png";